// Otis 2026-09-11 : bouton « Ajouter » des suggestions du panier latéral (snippets/otis-upsell-panier.liquid).
// Chargé sur toutes les pages par layout/theme.liquid : un script placé dans le tiroir lui-même ne s'exécutait pas
// quand le tiroir était redessiné après un premier ajout (panier vide à l'arrivée), et les boutons restaient sans effet.
import { CartAddEvent } from '@theme/events';

if (!window.__otisUpsell) {
  window.__otisUpsell = true;
  const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  document.addEventListener('click', async (e) => {
    const btn = e.target instanceof Element ? e.target.closest('[data-otis-upsell-add]') : null;
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    const libelle = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Ajout…';
    try {
      const r = await fetch(racine + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(btn.dataset.otisUpsellAdd), quantity: 1 }] }),
      });
      if (!r.ok) throw new Error('ajout refusé');
      const cart = await (await fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      try {
        document.dispatchEvent(new CartAddEvent(cart, 'otis-upsell', { source: 'otis-upsell', itemCount: cart.item_count, sections: {} }));
      } catch (err) {
        location.reload();
      }
    } catch (err) {
      btn.textContent = 'Indisponible';
      setTimeout(() => { btn.textContent = libelle; btn.removeAttribute('aria-busy'); }, 2000);
    }
  });
}
